import { getUnitPricesQuery } from '@spotahome/marketplace-common/src/graphql/queries/unitPrices';
import getGqlClient from '@spotahome/marketplace-common/src/graphql/client';

export const isValidPriceRange = ({ minPrice, maxPrice }) =>
  minPrice <= maxPrice || (minPrice && !maxPrice);

export const requestUnitPrices = async ({
  cityId,
  adaptedFilters,
  maxPriceInCity
}) => {
  try {
    const { data } = await getUnitPricesQuery(getGqlClient())(
      cityId,
      adaptedFilters
    );

    return data.unitPrices.filter(price => price <= maxPriceInCity);
  } catch (error) {
    if (error.message !== 'CANCELED') {
      console.error(error);
    }
    return [];
  }
};
